import axios from 'axios'

export const client = axios.create({
    baseURL: '/api',
    headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
})

export function injectToken(token: string) {
    client.defaults.headers.common.Authorization = `Bearer ${token}`
}

export function setLocale(locale: string) {
    client.defaults.headers.common['Accept-Language'] = locale
}
